// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"6dd2525b","118":"82554630","192":"5dcd572f","268":"8d91e700","392":"45863275","826":"37602348","961":"07d65526"}[chunkId] + ".chunk.js";
};